import {sortBy} from 'lodash'

import {mutationTypes} from '#/notes/store/authors/mutationTypes'
import {actionTypes} from '#/notes/store/authors/actionTypes'

const actions = {
  async [actionTypes.FETCH_AUTHORS] ({commit, getters}) {
    const users = sortBy(await getters.userService.fetchAllUsers(), 'attributes.name')
    const userData = users.map(u => ({
      // "displayName" is prepared to be used as a select option label to represent an user
      // This serves a better approach to differentiate between users with same "name" at UI level
      ...u.attributes, username: u.username, displayName: `${u.attributes.name} (${u.attributes.email})`
    }))
    commit(mutationTypes.SET_AUTHORS, userData)
  }
}

export default actions
